import { useEffect, useRef } from 'preact/hooks';
import { reportBootstrapFailure } from '../bootstrap.js';
import { initializeI18n } from '../platform/i18n/index.js';
import { initializeKUniRuntime } from '../runtime/index.js';
import { initializeCampusEditor } from '../features/campus-editor/runtime.js';

/**
 * Owns application bootstrap from Preact without causing a second render of the
 * controller-owned DOM islands after initialization.
 */
export function useKUniRuntime() {
  const status = useRef('booting');

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        await initializeI18n();
        if (!active) return;
        await initializeKUniRuntime();
        status.current = 'ready';
      } catch (error) {
        if (!active) return;
        status.current = 'error';
        reportBootstrapFailure(error, document.getElementById('root') || document.body);
      }
    })();

    return () => { active = false; };
  }, []);

  return status;
}

export function useCampusEditorRuntime() {
  const status = useRef('booting');

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        await initializeI18n();
        if (!active) return;
        await initializeCampusEditor();
        status.current = 'ready';
      } catch (error) {
        if (!active) return;
        status.current = 'error';
        reportBootstrapFailure(error, document.getElementById('root') || document.body);
      }
    })();

    return () => { active = false; };
  }, []);

  return status;
}
